var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.176758,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9894 34.824L31.3852 38.8392L29.3643 53.4894L37.7178 45.1365L36.4536 43.8723L37.7756 42.5505L41.6254 46.4008L40.3035 47.7225L39.0395 46.4584L30.6849 54.8125L45.3381 52.792L49.3534 44.1879L39.9894 34.824Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9915 29.4613C45.8 29.2697 45.5346 29.1707 45.2643 29.1899C44.9941 29.2091 44.7455 29.3446 44.5828 29.5614L41.4907 33.6842L50.4923 42.6859L54.6152 39.5938C54.832 39.4311 54.9675 39.1825 54.9867 38.9122C55.006 38.6419 54.9068 38.3766 54.7153 38.185L45.9915 29.4613Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/Design.3ef96363b69e0d34326476582eb84b9d.svg";
export { ForwardRef as ReactComponent };